export const CUSTOM_JOB_PREFIX = "cus-";
